import Category from "./Category/Routes";
import Product from "./Product/Routes";

export default [...Category, ...Product];
